/** SSS / FAQ sayfası — panel açık tema SSOT */

import { PANEL } from "./panelTokens";
import { panelFormCardWideSx } from "./panelFormSx";

export const panelFaqContainerSx = {
  ...panelFormCardWideSx,
  maxWidth: 960,
  mx: "auto",
  mt: 1,
};

export const panelFaqHeroSx = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: { xs: "flex-start", md: "center" },
  justifyContent: "space-between",
  gap: 2,
  px: { xs: 2.5, md: 3 },
  py: { xs: 2.5, md: 3 },
  bgcolor: PANEL.fill.muted,
  borderBottom: `1px solid ${PANEL.border}`,
};

export const panelFaqContactChipSx = {
  bgcolor: PANEL.surface,
  color: PANEL.text.body,
  fontWeight: 600,
  fontSize: "0.8125rem",
  borderRadius: PANEL.radius.chip,
  border: `1px solid ${PANEL.border}`,
  px: 0.5,
  height: "auto",
  py: 0.75,
  maxWidth: { xs: "100%", md: 420 },
  "& .MuiChip-label": {
    whiteSpace: "normal",
    lineHeight: 1.45,
    px: 1,
  },
  "& .MuiChip-icon": {
    color: PANEL.accent.text,
    ml: 0.75,
  },
};

export const panelFaqContentSx = {
  px: { xs: 2, md: 3 },
  py: { xs: 2.5, md: 3 },
};

export const panelFaqCategoryTitleSx = {
  color: PANEL.accent.text,
  fontWeight: 700,
  fontSize: "0.8125rem",
  letterSpacing: "0.06em",
  textTransform: "none",
};

export const panelFaqCategoryDividerSx = {
  flexGrow: 1,
  borderColor: PANEL.border,
};

export const panelFaqCategoryCountChipSx = {
  bgcolor: PANEL.fill.muted,
  color: PANEL.text.muted,
  border: `1px solid ${PANEL.border}`,
  fontWeight: 600,
  fontSize: "0.72rem",
  height: 24,
};

export const panelFaqAccordionSx = {
  bgcolor: PANEL.surface,
  borderRadius: `${PANEL.radius.cardSm} !important`,
  border: `1px solid ${PANEL.border}`,
  boxShadow: "none",
  overflow: "hidden",
  "&:before": { display: "none" },
  transition: "border-color 0.15s ease, box-shadow 0.15s ease",
  "&.Mui-expanded": {
    borderColor: PANEL.accent.softBorder22,
    boxShadow: PANEL.shadow.card,
  },
};

export const panelFaqAccordionSummarySx = {
  px: { xs: 2, md: 2.5 },
  py: { xs: 1.25, md: 1.5 },
  minHeight: "auto !important",
  "&.Mui-expanded": { minHeight: "auto !important" },
  "& .MuiAccordionSummary-content": { my: 0.5 },
};

export const panelFaqQuestionBadgeSx = {
  color: PANEL.text.label,
  textTransform: "none",
  letterSpacing: "0.05em",
  fontSize: "0.6875rem",
  fontWeight: 600,
};

export const panelFaqQuestionSx = {
  color: PANEL.text.primary,
  fontWeight: 600,
  fontSize: { xs: "0.9375rem", sm: "1rem" },
  lineHeight: 1.45,
};

export const panelFaqAnswerSx = {
  color: PANEL.text.body,
  lineHeight: 1.7,
  fontSize: "0.9375rem",
};

export const panelFaqAccordionDetailsSx = {
  px: { xs: 2, md: 2.5 },
  pt: 0,
  pb: { xs: 2, md: 2.25 },
  borderTop: `1px solid ${PANEL.pageBg}`,
};
